module.exports = __webpack_public_path__ + "static/media/update-app-selected.9ddc804e.svg";